import { Component, OnInit, Inject, OnDestroy } from '@angular/core';

import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { LocalizationService } from '@services/localization.service';

@Component({
  selector: 'home-page-dialog',
  templateUrl: '../sharedTemplates/home-page-dialog.html',
})
export class HomePageDialog {
  constructor(public dialogRef: MatDialogRef<HomePageDialog>, public _LocalizationService: LocalizationService) {}

  ngAfterViewInit() {
    this.dialogRef.updatePosition({ bottom: '20px' });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
